/* eslint-disable */
import legacy$ from 'jquery';
import $ from 'jquery';
import ko from 'knockout';
import backbone from 'backbone';
import _ from 'underscore';
import Promise from 'bluebird';
import pageContext from '@bingads-webui-static-legacy/page-context';
import UploadConversionsTemplate from '@bingads-webui-static-legacy/uet/template/uploadConversions/uploadConversions.pug';
import UploadConversionsViewModel from '@bingads-webui-static-legacy/uet/viewmodel/uploadConversions/index';
import FilePickerView from '@bingads-webui-static-legacy/uet/view/uploadConversions/filePicker';
import * as _HistoryGrid from '@bingads-webui-campaign-legacy/conversion-tracking/upload-conversions/history-grid';
import UploadFileTask from '@bingads-webui-static-legacy/uet/view/uploadConversions/uploadFileTask';
import PollerTask from '@bingads-webui-static-legacy/uet/view/uploadConversions/pollerTask';
import * as _ChangesView from '@bingads-webui-campaign-legacy/conversion-tracking/upload-conversions/changes-view';
import ErrorView from '@bingads-webui-static-legacy/uet/view/uploadConversions/errorView';
import Collaborator from '@bingads-webui-static-legacy/uet/view/uploadConversions/collaborator';
import ModalManager from '@bingads-webui-static-legacy/uet/view/uploadConversions/modalManager';
import TemplateFileUtil from '@bingads-webui-static-legacy/uet/view/uploadConversions/templateFileUtil';
import localStorage from '@bingads-webui-component-legacy/storage/localStorage';
import dateUtils from '@bingads-webui-component-legacy/humanize/date';
import instrumentation from '@bingads-webui-static-legacy/instrumentation/index';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';
import setting from '@bingads-webui-static-legacy/instrumentation/campaignSchemaAndSetting';
import '@bingads-webui-static-legacy/instrumentation/instrumentation';
import '@bingads-webui-component-legacy/bingads-grid/service/fetch-pagination';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!uet');
var HistoryGrid = _HistoryGrid.default;
var ChangesView = _ChangesView.default;
var modalManager = new ModalManager(i18n.getString('UnifiedEventTracking_UploadConversions_ModalMessage'));
function displayRole(name, options, keepCurrent) {
  return function (args) {
    var $el = this.$('.operation-area');
    if (!keepCurrent) {
      $el.empty();
      this.currentRoles = {};
    }
    if (!this.currentRoles[name]) {
      instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, '/uploadConversions/index/displayRole', 'Passed-in name: ' + name + ', keepCurrent: ' + keepCurrent);
      var role = this.collab.role(name, _.isFunction(options) ? options(args) : options);
      var view = role.getView();
      !options && _.isFunction(view.recoverBinding) && view.recoverBinding();
      this.$('.operation-area').append(view.el);
      this.currentRoles[name] = role;
      if (role.modal) {
        modalManager.on();
      } else {
        modalManager.off();
      }
    }
  };
}
function displayHistoryGrid() {
  this.historyGrid = new HistoryGrid();
  this.historyGrid.on('error:system', this.options.onError);
  this.$('.upload-history').empty().html(this.historyGrid.render().el);
}
function refreshHistoryGrid() {
  if (this.historyGrid) {
    this.historyGrid.grid.refresh({
      force: true
    });
  } else {
    displayHistoryGrid.apply(this);
  }
}
function setStatus(status) {
  if (!pageContext || !pageContext.CurrentAccount) {
    return;
  }
  var aid = pageContext.CurrentAccount.Id;
  var cid = pageContext.CurrentAccount.AdvertiserCustomerID;
  localStorage.set('uet_upload_status', _.extend({}, _.pick(status, 'state', 'TaskId', 'ExecutionId', 'FileName'), {
    time: dateUtils.toString(new Date(), 'u'),
    cid: cid,
    aid: aid
  }));
}
function getStatus() {
  if (!pageContext || !pageContext.CurrentAccount) {
    return null;
  }
  var stat = localStorage.get('uet_upload_status');
  var aid = pageContext.CurrentAccount.Id;
  var cid = pageContext.CurrentAccount.AdvertiserCustomerID;
  if (!stat || !stat.aid || !stat.cid || stat.aid !== aid || stat.cid !== cid) {
    return null;
  }
  if (stat && stat.time && stat.state === 'processing') {
    var start = dateUtils.parse(stat.time, 'u');
    var now = new Date();
    if (now - start > 900000) {
      resetStatus();
      return null;
    }
  }
  return stat;
}
function resetStatus() {
  localStorage.invalidate('uet_upload_status');
}
function resume() {
  return Promise.resolve(getStatus());
}
function closeView() {
  this.sharedInfo = {};
  resetStatus();
  displayRole('filePickerView', this.filePickerOptions).call(this);
}
function composePreviewTableData(data, fileName) {
  var identifierOf = function (type) {
    return _.chain(data.OfflineConversionFiles).where({
      Type: type
    }).first().result('Identifier').value();
  };
  return {
    data: data,
    sessionId: data.SessionId,
    filename: fileName,
    errorsIdentifier: identifierOf('ErrorOnlyResultFile')
  };
}
function composeReviewTableData(data) {
  var identifierOf = function (type) {
    return _.chain(data.OfflineConversionFiles).where({
      Type: type
    }).first().result('Identifier').value();
  };
  return {
    data: data,
    resultsIdentifier: identifierOf('AllRecordsResultFile'),
    errorsIdentifier: identifierOf('ErrorOnlyResultFile')
  };
}
function composeErrorViewOptions(obj) {
  var ret;
  ret = obj || ({});
  ret.log = _.extend({}, _.pick(this.options, 'trackingId', 'sessionId', 'customerId'), {
    Date: new Date().toUTCString()
  }, this.sharedInfo, ret.log);
  if (ret.errorMsgKey === 'UnifiedEventTracking_UploadConversions_GenericError') {
    var msg = JSON.stringify(ret.log);
    this.options.logError(msg);
    if (!ret.isUserError) {
      instrumentation.logError('UploadConverions/index/composeErrorViewOptions', msg);
    }
  }
  return ret;
}
function extractSharedInfo(key) {
  return function (obj) {
    var ret = {};
    this.sharedInfo = _.extend({}, this.sharedInfo, _.pick(obj, 'TaskId', 'ExecutionId', 'FileName'));
    ret[key] = obj[key];
    return ret;
  };
}
function wrapWithKey(key) {
  return function (obj) {
    var result = {};
    result[key] = obj;
    return result;
  };
}
var view = backbone.View.extend({
  initialize: function (options) {
    this.options = _.defaults({}, options, {
      helpId: 'help:app72000',
      onError: (function () {
        this.ko_model.hasError(true);
      }).bind(this),
      logError: function () {}
    });
    this.filePickerOptions = {
      newFilePickerTip: this.options.newFilePickerTip,
      isNewUI: this.options.isNewUI,
      offlineConversionUploadButton: this.options.offlineConversionUploadButton
    };
    this.options.onError = _.wrap(this.options.onError, (function (func, err) {
      func();
      var log = _.extend({}, err, _.pick(this.options, 'trackingId', 'sessionId', 'customerId'), {
        Date: new Date().toUTCString()
      });
      var msg = JSON.stringify(log);
      instrumentation.logError('uploadConversions/index/onError', msg);
      this.options.logError(msg);
    }).bind(this));
    var self = this;
    this.currentRoles = {};
    var bindEvent = function (roleName, instance, eventName, handler) {
      instance.on(eventName, function () {
        if (self.currentRoles[roleName] === instance) {
          return handler.apply(instance, arguments);
        }
      });
    };
    var viewStrategy = {
      initialize: function () {
        this.render();
      },
      destroy: function () {
        this.remove();
      },
      bindEvent: bindEvent,
      extend: {
        getView: function () {
          return this;
        }
      }
    };
    var taskStrategy = {
      initialize: function () {
        this.view.render();
        this.run();
      },
      destroy: function () {
        this.view.remove();
      },
      bindEvent: bindEvent,
      extend: {
        getView: function () {
          return this.view;
        }
      }
    };
    this.collab = new Collaborator({
      'filePickerView': {
        factory: Collaborator.factory(FilePickerView, viewStrategy, this.filePickerOptions),
        events: {
          'fileSelected': displayRole('uploadFileTask', wrapWithKey('file')).bind(this)
        }
      },
      'uploadFileTask': {
        factory: Collaborator.factory(UploadFileTask, taskStrategy, {
          statusText: this.options.isNewUI ? i18n.getString('BulkUpload_Processing_Message') : i18n.getString('UnifiedEventTracking_UploadConversions_UploadFile_Status'),
          completeText: this.options.isNewUI ? i18n.getString('BulkUpload_Processing_Message') : i18n.getString('UnifiedEventTracking_UploadConversions_UploadFile_CompleteStatus')
        }),
        events: {
          'done': (function (args) {
            setStatus({
              state: 'processing',
              TaskId: args.TaskId,
              ExecutionId: args.ExecutionId,
              FileName: args.FileName
            });
            displayRole('processFileTask', extractSharedInfo('ExecutionId').bind(this)).call(this, args);
          }).bind(this),
          'error': displayRole('errorView', composeErrorViewOptions.bind(this)).bind(this)
        },
        extend: {
          modal: true
        }
      },
      'processFileTask': {
        factory: Collaborator.factory(PollerTask, taskStrategy, {
          statusText: this.options.isNewUI ? i18n.getString('BulkUpload_Processing_Message') : i18n.getString('UnifiedEventTracking_UploadConversions_ProcessFile_Status'),
          completeText: i18n.getString('UnifiedEventTracking_UploadConversions_ProcessFile_CompleteStatus')
        }),
        events: {
          'done': (function (args) {
            var stat = getStatus();
            displayRole('changesPreviewView', composePreviewTableData(args, stat.FileName), true).call(this, args);
          }).bind(this),
          'error': displayRole('errorView', composeErrorViewOptions.bind(this)).bind(this)
        }
      },
      'changesPreviewView': {
        factory: Collaborator.factory(ChangesView, viewStrategy, {
          type: 'preview',
          isNewUI: this.options.isNewUI
        }),
        events: {
          'discard': (function () {
            this.sharedInfo = {};
            resetStatus();
            displayRole('filePickerView').call(this);
          }).bind(this),
          'error': (function (obj) {
            resetStatus();
            displayRole('errorView', composeErrorViewOptions.bind(this, obj)).call(this);
          }).bind(this),
          'startApply': (function (args) {
            setStatus({
              state: 'applying',
              TaskId: args.TaskId,
              ExecutionId: args.ExecutionId,
              FileName: args.FileName
            });
            displayRole('applyChangesTask', extractSharedInfo('ExecutionId').bind(this)).call(this, args);
          }).bind(this)
        }
      },
      'applyChangesTask': {
        factory: Collaborator.factory(PollerTask, taskStrategy, {
          statusText: i18n.getString('UnifiedEventTracking_UploadConversions_ApplyChanges_Status'),
          completeText: i18n.getString('UnifiedEventTracking_UploadConversions_ApplyChanges_CompleteStatus')
        }),
        events: {
          'done': (function (data) {
            resetStatus();
            displayRole('changesReviewView', composeReviewTableData, true).call(this, data);
            refreshHistoryGrid.call(this);
          }).bind(this),
          'error': displayRole('errorView', composeErrorViewOptions.bind(this)).bind(this)
        }
      },
      'changesReviewView': {
        factory: Collaborator.factory(ChangesView, viewStrategy, {
          type: 'review',
          isNewUI: this.options.isNewUI
        }),
        events: {
          'error': displayRole('errorView', composeErrorViewOptions.bind(this)).bind(this),
          'close': (function () {
            closeView.call(this);
            var emptyFunc = function () {};
            emptyFunc.asLoggingStart(setting.ACTIVITYNAME.ReturnToFilePicker, setting.SCENARIONAME.UploadBulkSheet)();
          }).bind(this)
        }
      },
      'errorView': {
        factory: Collaborator.factory(ErrorView, viewStrategy),
        events: {
          'close': closeView.bind(this)
        }
      }
    });
    this.historyGrid = null;
    this.ko_model = new UploadConversionsViewModel({
      hideTutorial: localStorage.get('uet_upload_tut_hide') || false
    });
    this.p$status = resume.call(this);
    this.sharedInfo = {};
  },
  events: {
    'click .goal-page-link': 'goToGoalsPage'
  },
  render: (function () {
    if (this.options.perfMarker) {
      this.options.perfMarker.willRender();
    }
    this.$el.html(UploadConversionsTemplate({
      i18n: i18n,
      _: _,
      goalLink: '<a class="goal-page-link" href="javascript:void(0);">' + i18n.getString('UnifiedEventTracking_Goal_Page') + '</a>',
      helpId: this.options.helpId,
      isNewUI: this.options.isNewUI
    }));
    if (!this.options.isNewUI) {
      this.$('a#tutFileXls').attr('href', TemplateFileUtil.excelFileUrl);
      this.$('a#tutFileCsv').attr('href', TemplateFileUtil.csvFileUrl);
    } else if (this.options.tutorialView) {
      this.$('.tutorial-section-for-uinext').empty().append(this.options.tutorialView.render().$el);
    }
    ko.applyBindings(this.ko_model, this.el);
    displayHistoryGrid.call(this);
    this.p$status.then((function (status) {
      if (status && status.state === 'processing') {
        instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, '/uploadConversions/index/render', 'Cached status: processing, TaskId: ' + status.TaskId + ' , ExecutionId: ' + status.ExecutionId);
        displayRole('processFileTask', extractSharedInfo('ExecutionId').bind(this)).call(this, {
          TaskId: status.TaskId,
          ExecutionId: status.ExecutionId,
          FileName: status.FileName
        });
      } else if (status && status.state === 'applying') {
        instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, '/uploadConversions/index/render', 'Cached status: applying, TaskId: ' + status.TaskId + ' , ExecutionId: ' + status.ExecutionId);
        displayRole('applyChangesTask', extractSharedInfo('ExecutionId').bind(this)).call(this, {
          TaskId: status.TaskId,
          ExecutionId: status.ExecutionId,
          FileName: status.FileName
        });
      } else {
        instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, '/uploadConversions/index/render', 'No cached status');
        displayRole('filePickerView', this.filePickerOptions).call(this);
      }
    }).bind(this)).catch(this.options.onError);
    if (this.options.perfMarker) {
      this.options.perfMarker.done();
    }
    return this;
  }).asLoggingStart(setting.ACTIVITYNAME.RenderBulkUpload, setting.SCENARIONAME.UploadConverions),
  goToGoalsPage: (function () {
    window.App.navigate('customer/:customer_id/account/:account_id/uet/goals');
  }).asLoggingStart(setting.ACTIVITYNAME.ClickOnPageLink, setting.SCENARIONAME.GoToUetGoalsPageViaHelpLinkInEntryPage),
  reactivate: (function () {
    displayHistoryGrid.call(this);
    this.recoverBinding();
    _.each(this.currentRoles, function (role, name) {
      instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, '/UploadConversions/index/reactivate', 'Recover binding for role ' + name);
      role.getView().recoverBinding();
    });
  }).asLoggingStart(setting.ACTIVITYNAME.ReactivateBulkUpload, setting.SCENARIONAME.uploadConversions),
  recoverBinding: function () {
    ko.cleanNode(this.el);
    this.undelegateEvents();
    this.delegateEvents();
    ko.applyBindings(this.ko_model, this.el);
  }
});
export default view;

